import { Component, inject, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
} from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { filter } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor } from '@angular/material/button';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  imports: [MatIcon, MatAnchor, RouterLink, AsyncPipe],
})
export class BreadcrumbComponent implements OnInit {
  private readonly activeRoute = inject(ActivatedRoute);

  private readonly authService = inject(AuthService);

  private readonly router = inject(Router);

  protected routes: Array<{ path: string; url: string; beta?: boolean }> = [];

  protected isUser$ = this.authService.user$;

  ngOnInit() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        this.routes = [
          {
            path: $localize`:component breadcrumb | racine:dashboard`,
            url: '/',
          },
        ];
        this.createBreadcrumbs(this.activeRoute, '');
      });
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string): void {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return;
    }

    for (const child of children) {
      const param = child.snapshot.data.breadcrumb;
      const beta = child.snapshot.data.beta;
      const routeURL: string = child.snapshot.url
        .map((segment) => segment.path)
        .join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }
      const previous = this.routes[this.routes.length - 1];
      if (param && previous && previous.path !== param) {
        this.routes.push({ path: param, url, beta });
      }
      this.createBreadcrumbs(child, url);
    }
  }
}
